var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8896 5.21139C18.6958 8.01758 18.8313 12.4837 16.296 15.4502L20.8774 20.0316L19.4632 21.4458L14.8062 16.7892C11.8665 18.7992 7.82111 18.4993 5.21139 15.8896C2.26287 12.9411 2.26287 8.15992 5.21139 5.21139C8.15992 2.26287 12.9411 2.26287 15.8896 5.21139ZM6.62561 6.62561C4.45813 8.79308 4.45813 12.3079 6.62561 14.4754C8.79308 16.6429 12.3079 16.6429 14.4754 14.4754C16.6429 12.3079 16.6429 8.79308 14.4754 6.62561C12.3079 4.45813 8.79308 4.45813 6.62561 6.62561Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsearch);
export default __webpack_public_path__ + "static/media/msearch.c6aae885334b86fae9a1ed95579881c5.svg";
export { ForwardRef as ReactComponent };